import buttons from './buttons'
import cards from './cards'
import checkbox from './checkbox'
import fields from './fields'
import icons from './icons'
import labels from './labels'
import menus from './menus'
import messages from './messages'
import tables from './tables'
import titles from './titles'

const styles = {
  buttons: buttons,
  cards: cards,
  fields: fields,
  icons: icons,
  labels: labels,
  menus: menus,
  messages: messages,
  tables: tables,
  checkbox: checkbox,
  titles: titles,
}

styles.dark = (_dark = true) => {
  return _dark ? 'retour' : null
}

export default styles



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/directives/resources/styles/styles.js